import React, { useState } from "react";
import "./loginregister.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { apiurl } from "../../Constants";

function Register() {
  const [inputfields, setInputfields] = useState({
    name: "",
    email: "",
    phonenumber: "",
  });

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateValues = (inputvalues) => {
    let errors = {};
    if (!inputvalues.name) errors.name = "Name is required";
    if (!inputvalues.email) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputvalues.email)) {
      errors.email = "Please enter a valid email address";
    }
    if (!inputvalues.phonenumber) {
      errors.phonenumber = "Phone number is required";
    } else if (!/^\d{11}$/.test(inputvalues.phonenumber)) {
      errors.phonenumber = "Phone number must be 11 digits";
    }
    return errors;
  };

  // Maps a backend error payload (string | object | array) into
  // the same {field: message} shape used by client-side validation.
  const mapApiErrorsToFields = (apiErrors) => {
    const fieldErrors = {};

    if (typeof apiErrors === "string") {
      fieldErrors.general = apiErrors;
      return fieldErrors;
    }

    // Backend field names -> local field names
    const fieldMap = {
      name: "name",
      email: "email",
      phone: "phonenumber",
      phonenumber: "phonenumber",
    };

    Object.keys(apiErrors).forEach((key) => {
      const message = Array.isArray(apiErrors[key])
        ? apiErrors[key].join(" ")
        : apiErrors[key];
      const localKey = fieldMap[key] || key;
      fieldErrors[localKey] = message;
    });

    return fieldErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationerrors = validateValues(inputfields);
    setErrors(validationerrors);

    if (Object.keys(validationerrors).length === 0) {
      setLoading(true);
      try {
        const res = await axios.post(apiurl + "register", {
          name: inputfields.name,
          email: inputfields.email,
          phone: inputfields.phonenumber,
          password: "123456",
          password_confirmation: "123456",
        });

        console.log("Register API Response:", res.data);

        if (res.status === 200 && (res.data.success || res.data.status === true)) {
          toast.success("Registration successful ✅", { autoClose: 2000 });
          navigate("/login");
        } else {
          // Show whatever the backend actually says, not a generic message
          const apiErrors = res.data.error || res.data.errors;
          if (apiErrors) {
            const fieldErrors = mapApiErrorsToFields(apiErrors);
            setErrors((prev) => ({ ...prev, ...fieldErrors }));
            if (fieldErrors.general) toast.error(fieldErrors.general, { autoClose: 2000 });
          } else {
            toast.error(res.data.message || "Registration failed", { autoClose: 2000 });
          }
        }
      } catch (error) {
        console.error("Register API Error:", error.response || error.message);
        const apiErrors = error.response?.data?.error || error.response?.data?.errors;

        if (apiErrors) {
          const fieldErrors = mapApiErrorsToFields(apiErrors);
          setErrors((prev) => ({ ...prev, ...fieldErrors }));
          if (fieldErrors.general) toast.error(fieldErrors.general, { autoClose: 2000 });
        } else {
          toast.error(
            error.response?.data?.message || "Registration failed",
            { autoClose: 2000 }
          );
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChange = (e) => {
    setInputfields({ ...inputfields, [e.target.name]: e.target.value });
  };

  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) setInputfields({ ...inputfields, [name]: value });
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    if (/^[a-zA-Z\s]*$/.test(value)) setInputfields({ ...inputfields, [name]: value });
  };

  return (
    <section className="pt-40 pb-40 loginregister_section">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12"></div>
          <div className="col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <h2 className="text-center">Register</h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    Name <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={inputfields.name}
                    onChange={handleNameChange}
                    className="form-control"
                    placeholder="Enter your Name"
                  />
                  {errors.name && (
                    <p style={{ fontSize: "12px", color: "red" }}>{errors.name}</p>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Email <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={inputfields.email}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Enter your Email"
                  />
                  {errors.email && (
                    <p style={{ fontSize: "12px", color: "red" }}>{errors.email}</p>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Phone Number <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="text"
                    name="phonenumber"
                    value={inputfields.phonenumber}
                    onChange={handlePhoneNumberChange}
                    maxLength={11}
                    className="form-control"
                    placeholder="Enter your Phone Number"
                  />
                  {errors.phonenumber && (
                    <p style={{ fontSize: "12px", color: "red" }}>{errors.phonenumber}</p>
                  )}
                </div>

                {errors.general && (
                  <p style={{ fontSize: "13px", color: "red", textAlign: "center" }}>
                    {errors.general}
                  </p>
                )}

                <div className="mb-3 text-center">
                  <button className="btn_1_1" type="submit" disabled={loading}>
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>

              <p className="text-center mb-0">
                Already have an Account?{" "}
                <Link
                  to="/login"
                  style={{ color: "#76a70e", textDecoration: "none" }}
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Register;